module.exports = __webpack_public_path__ + "static/media/error.cfd055c9.svg";